var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"padding-top":"0px"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"lg":"12"}},[_c('v-card',{staticClass:"bcg",attrs:{"flat":""}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }